import { render, staticRenderFns } from "./SearchOwner.vue?vue&type=template&id=806cc4a8&scoped=true"
import script from "./SearchOwner.vue?vue&type=script&lang=js"
export * from "./SearchOwner.vue?vue&type=script&lang=js"
import style0 from "./SearchOwner.vue?vue&type=style&index=0&id=806cc4a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806cc4a8",
  null
  
)

export default component.exports